function addToCartViaForm(formElement) {
    const formData = new FormData(formElement);
    const button = formElement.querySelector('.quick-add');
    if (button)
        button.classList.add('loading');
    fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
    }).then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok')
        }
        return response.json()
    }).then(data => {
        updateCartItems(formData)
        $('#CartDrawer-Checkout').removeAttr('disabled');
    }).catch(error => {
        console.error('Error adding product to cart:', error)
    }).finally(() => {
        if (button)
            button.classList.remove('loading')
        $.getJSON('/cart.js', function(data) {
            console.log(data.item_count);
            $('#CartDrawer-Checkout').removeAttr('disabled');
            if (data.item_count > 0) {
                $('.cart-bubble').removeClass('hide');
                $('.cart-bubble').text(data.item_count);
                $('#cart-header').removeClass('is-empty');
            }
        });
    })
}

function updateCartItems(formData) {
    try {
        $.ajax({
            type: 'GET',
            url: '/cart',
            dataType: 'html',
            success: function(data) {
                var cartContent = $(data).find('#CartDrawer');
                var cartItems = cartContent.find('#CartDrawer-CartItems');
                var cartTotals = cartContent.find('.cart-drawer__footer');
                $('.cart-drawer-wrapper').removeClass("d-none");
                $('.cart-empty-wrapper').removeClass("d-block");
                $('.cart-empty-wrapper').addClass("d-none");
                $('cart-drawer').removeClass("is-empty");
                $('cart-drawer-items').removeClass("is-empty");
                $('#CartDrawer-CartItems').html(cartItems);
                $('.cart-drawer__footer').html(cartTotals);
                var offcanvasLink = document.querySelector('[data-bs-target="#offcanvasRight"]');
                var cartBubbleText = $(data).find('.cart-bubble').text().replace(/\s/g, '');
                var cartBubbleValue = parseInt(cartBubbleText, 10);
                
                if (cartBubbleValue === 0) {
                    $('.cart-bubble').addClass('hide')
                } else {
                    $('.cart-bubble').text(cartBubbleValue);
                }
                if (offcanvasLink) {
                    offcanvasLink.click()
                } else {
                    console.error('Offcanvas link not found.')
                }
            },
            error: function(xhr, status, error) {
                console.error('Error updating cart:', error)
            }
        })
      
    } catch (error) {}
}

function updatePopupItemsContent() {
    fetch('/cart.js').then(response => response.json()).then(data => {
        const updatedPopupItems = generateUpdatedPopupItemsHTML(data)
    }).catch(error => {
        console.error('Error fetching data:', error)
    })
}

function generateUpdatedPopupItemsHTML(cartData) {
    let updatedHTML = '';
    if (cartData.item_count === 0) {} else {
        for (const item of cartData.items) {
            const optionsHTML = item.options_with_values.map(var_item => {
                const modifiedName = var_item.name.replace('Title', '').replace('var_select', '').replace('compatible_var', '');
                if (var_item.name == "Title") {} else {
                    return `<div class="product-option"><small class="popup-variant black-f">${modifiedName}: </small><small class="popup-variant black-f">${var_item.value}</small></div>`
                }
            }).join('');
            const maxQuantity = item.quantity
            const itemHTML = `
                  <div class="popup-item" id="product-${item.id}">
                      <div class="popup-img" style="
                          background: url(${item.image}), #f6f6f6;
                          background-size: cover;
                          background-position: center;
                          background-repeat: no-repeat;
                          display:block;
                      "></div>
                      <div class="popup-details">
                          <div class="popup-top">
                              <div class="popup-product">
                                  <h4 class="popup-title">${item.product_title}</h4>
                                  ${optionsHTML}
                              </div>
                              <div class="popup-price">
                                </div>
                          </div>
                          <div class="popup-bottom">
                              <div class="popup-qty">
                                  <button class="popup-btn-qty minus" id="popup-minus-${item.id}"><i class="fa-solid fa-minus"></i></button>
                                  <input type="number" class="popup-input-qty" value="${item.quantity}" id="popup-qty-${item.id}"  disabled>
                                  <button class="popup-btn-qty add" id="popup-plus-${item.id}"><i class="fa-solid fa-plus"></i></button>
                              </div>
                              <a href="javascript:void(0)" class="popup-remove" id="remove-${item.id}">
                                  Remove
                              </a>
                          </div>
                      </div>
                  </div>
              `;
            updatedHTML += itemHTML
        }
        $('.popup-button a').text('Checkout')
    }
    return updatedHTML
}
document.addEventListener("DOMContentLoaded", function() {
    const addToCartForms = document.querySelectorAll('form[data-quick-add]');
    if (addToCartForms) {
        addToCartForms.forEach(form => {
            form.addEventListener('submit', function(event) {
                event.preventDefault();
                addToCartViaForm(this)
            })
        })
    }
    const buyForms = document.querySelectorAll('[data-buy-form]');
    if (buyForms) {
        buyForms.forEach(form => {
            let buynow = form.querySelector('[data-buy-now]');
            buynow.addEventListener('click', function(event) {
                let formData = new FormData(form);
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    body: formData
                }).then(response => {
                    window.location.href = '/checkout';
                    return response.json()
                }).catch((error) => {
                    console.error('Error:', error)
                })
            })
        })
    }
})
